<his-plam [label]="setting().label | hisUi"
          [helptext]="setting().helptext | hisUi" [required]="setting().required"
          [title]="title()">
    <input #content [(ngModel)]="setting().value" class="inputWidth100" [readonly]="setting().readonly"
           [minlength]="setting().minLength"
           [maxlength]="setting().maxLength" [pattern]="setting().regex" />
</his-plam>
